import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import './Notification.pcss';
import {
	CollapsedNotification,
	INotificationsByType, NotificationTypeHelper,
} from "data/entities/INotification";
import {ReplyIcon} from "components/widgets/icons/ReplyIcon";
import {MentionIcon} from "components/widgets/icons/MentionIcon";
import {handleSpacePressed} from "utils";

interface INotificationProps {
	collapsedNotification:CollapsedNotification;
	onCollapsedNotificationNav:(collapsedNotification:CollapsedNotification)=>void;
	onDismissCollapsedNotification:(collapsedNotification:CollapsedNotification)=>void;
}

/**
 * Used:
 * home/Home
 */
@observer
export class Notification extends React.Component<INotificationProps> {
	@observable visible:boolean = true;

	handleDismissCollapsedNotification = () => {
		this.visible = false;
		this.props.onDismissCollapsedNotification(this.props.collapsedNotification);
	}
	handleCollapsedNotificationNav = () => {
		this.visible = false;
		this.props.onCollapsedNotificationNav(this.props.collapsedNotification);
	}


	render() {		

		if(!this.visible) {
			return null;
		}

		const onlyOneNotification = this.props.collapsedNotification.notificationsByTypeArray.length===1 && this.props.collapsedNotification.notificationsByTypeArray[0].notifications.length===1;

		let srNotification = this.props.collapsedNotification.title+" notification";
		if(onlyOneNotification) {
			const notification = validSingleNotification(this.props.collapsedNotification);
			if(null!==notification) {
				srNotification = `${notification.message} from ${this.props.collapsedNotification.title}. Click to view ${notification.referencedEntityName} and dismiss notification.`;
			}
		} else {
			srNotification = "";
			for(let i=0,ii=this.props.collapsedNotification.notificationsByTypeArray.length;i<ii;i++) {
				const notificationsByType = this.props.collapsedNotification.notificationsByTypeArray[i];
				srNotification.length>0 && (srNotification += " and ");
				const notification = notificationsByType.notifications[0];
				const notificationType = NotificationTypeHelper.notificationTypeForString(notification.type);
				srNotification += `${notificationsByType.notifications.length} ${notificationsByType.notifications.length===1?notificationType.type:notificationType.plural}`;
			}
			srNotification += ` from ${this.props.collapsedNotification.title}. Click to view all and dismiss notification.`;
		}

		return (
			<div className="notification" role={"listitem"}>
				<div className="notification-body">
					<div tabIndex={0} role={"button"} onClick={this.handleCollapsedNotificationNav} style={{cursor:'pointer'}}>
							<div className="visuallyhidden">{srNotification}</div>
							<h2 aria-hidden>{this.props.collapsedNotification.title}</h2>
							<div className="notification-message" aria-hidden>
								{onlyOneNotification ?
									<CollapsedNotificationMessageSingular collapsedNotification={this.props.collapsedNotification} />
									:
									<CollapsedNotificationMessageMulti collapsedNotification={this.props.collapsedNotification} />
								}
							</div>
						</div>
				</div>
				<div className="dismiss"><a tabIndex={0}
																		onClick={this.handleDismissCollapsedNotification}
																		onKeyDown={(e)=>{ handleSpacePressed(e, this.handleDismissCollapsedNotification);}}
																		aria-label={"Dismiss notification"}><span className="material-icons" aria-hidden>close</span></a></div>
			</div>
		)
	}
}

export const CollapsedNotificationMessageMulti = (props:{collapsedNotification:CollapsedNotification|null}) => {
	if(props.collapsedNotification===null) {
		return null;
	}
	return (
		<>
			{props.collapsedNotification.notificationsByTypeArray.map((notificationsByType:INotificationsByType)=>{
				const notification = notificationsByType.notifications[0];
				const count = notificationsByType.notifications.length;
				const notificationType = NotificationTypeHelper.notificationTypeForString(notification.type);
				return (
					<div className={'type-summary'} key={notification._id}>
						<div className="message-icon">{NotificationTypeHelper.isMention(notification)? <MentionIcon /> : <ReplyIcon /> }</div>
						<div className="message-text">{count} {count===1?notificationType.type:notificationType.plural}</div>
					</div>
				);
			})}
		</>
	)
}

function validSingleNotification(collapsedNotification:CollapsedNotification|null) {
	if(collapsedNotification===null || collapsedNotification.notificationsByTypeArray.length===0) {
		return null;
	}
	const notification = collapsedNotification.notificationsByTypeArray[0].notifications[0];
	if(notification.referencedEntityName==='Post') {
		return null;
	}
	return notification;
}

export const CollapsedNotificationMessageSingular = (props:{collapsedNotification:CollapsedNotification|null}) => {
	const notification = validSingleNotification(props.collapsedNotification);
	if(null==notification) {
		return null;
	}
	// if(props.collapsedNotification===null || props.collapsedNotification.notificationsByTypeArray.length===0) {
	// 	return null;
	// }
	// const notification = props.collapsedNotification.notificationsByTypeArray[0].notifications[0];
	// if(notification.referencedEntityName==='Post') {
	// 	return null;
	// }
	return (
		<>
			<div className="message-icon">{NotificationTypeHelper.isMention(notification)? <MentionIcon /> : <ReplyIcon /> }</div>
			<div className="message-text">{notification.message}</div>
		</>
	)
}
